import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2c037cb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "h5" }, "Settings", -1))
const _hoisted_2 = { class: "team-settings-panel__wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Organisation type ")
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" How large is your company ")
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Save changes ")
const _hoisted_8 = { class: "team-settings-panel__picture" }
const _hoisted_9 = { class: "delete-team__description" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Are you sure you want to delete workspace ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Delete workspace ")
const _hoisted_13 = {
  key: 0,
  class: "team-settings-delete"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "no-margin" }, "Delete workspace", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "no-margin" }, [
  /*#__PURE__*/_createTextVNode(" You will lose all the information stored related to the workspace, including individual profile data for all the workspace members. "),
  /*#__PURE__*/_createElementVNode("strong", null, "There’s no going back once you delete your workspace!")
], -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Delete workspace ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppSelect = _resolveComponent("AppSelect")!
  const _component_AppDropdown = _resolveComponent("AppDropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_AccountPictureUpload = _resolveComponent("AccountPictureUpload")!
  const _component_AppPanel = _resolveComponent("AppPanel")!
  const _component_Modal = _resolveComponent("Modal")!
  const _directive_test = _resolveDirective("test")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AppPanel, { class: "team-settings-panel" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_ctx.activeMembership)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveChanges && _ctx.saveChanges(...args)), ["prevent"]))
              }, [
                _createVNode(_component_AppInput, {
                  id: "team-settings-name",
                  type: "text",
                  label: "Organisation name",
                  placeholder: "Enter Organisation name",
                  modelValue: _ctx.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                  error: _ctx.fieldEmptyErrors.teamName,
                  maxlength: "30",
                  autofocus: ""
                }, null, 8, ["modelValue", "error"]),
                _createVNode(_component_AppDropdown, {
                  type: "simple",
                  class: "mb-responsive"
                }, {
                  label: _withCtx(() => [
                    _hoisted_3
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_AppSelect, {
                      modelValue: _ctx.industry,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.industry) = $event)),
                      options: _ctx.AVAILABLE_ORG_INDUSTRIES,
                      "close-on-select": "",
                      onKeydownCapture: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent","stop"]))
                    }, {
                      toggle: _withCtx(({ isFocusing, toggle }) => [
                        _createElementVNode("div", {
                          onClick: toggle,
                          onMousedown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent","stop"])),
                          class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                        }, [
                          _createVNode(_component_AppIcon, { name: "arrow" })
                        ], 42, _hoisted_4)
                      ]),
                      label: _withCtx(({ selected }) => [
                        _createTextVNode(_toDisplayString(selected ?? 'Select organisation industry'), 1)
                      ]),
                      "dropdown-item": _withCtx(({ option }) => [
                        _createElementVNode("p", null, _toDisplayString(option), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_AppDropdown, { type: "simple" }, {
                  label: _withCtx(() => [
                    _hoisted_5
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_AppSelect, {
                      "max-height": 220,
                      modelValue: _ctx.size,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.size) = $event)),
                      options: _ctx.AVAILABLE_TEAM_SIZES,
                      "close-on-select": "",
                      onKeydownCapture: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent","stop"])),
                      openDirection: "top"
                    }, {
                      toggle: _withCtx(({ isFocusing, toggle }) => [
                        _createElementVNode("div", {
                          onClick: toggle,
                          onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent","stop"])),
                          class: _normalizeClass(["app-dropdown__vue-select-trigger", { active: isFocusing }])
                        }, [
                          _createVNode(_component_AppIcon, { name: "arrow" })
                        ], 42, _hoisted_6)
                      ]),
                      label: _withCtx(({ selected }) => [
                        _createTextVNode(_toDisplayString(selected ? selected : 'Select company size'), 1)
                      ]),
                      "dropdown-item": _withCtx(({ option }) => [
                        _createElementVNode("p", null, _toDisplayString(option), 1)
                      ]),
                      _: 1
                    }, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_AppButton, {
                  loading: _ctx.isSaving,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["loading"])
              ], 32))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_AccountPictureUpload, {
              id: "team-settings-profile-picture",
              defaultAvatar: require('@/assets/images/default-team-avatar.png'),
              class: "user-onboarding-cards__picture-upload",
              theme: "squared",
              title: "Change workspace picture",
              isTeamAvatar: ""
            }, null, 8, ["defaultAvatar"])
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Modal, {
      id: "delete-team",
      title: "Delete workspace"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_AppButton, {
          theme: "secondary",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.ModalHandlerService.reset()))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
          theme: "danger",
          onClick: _ctx.deleteTeam,
          loading: _ctx.isDeleting
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }, 8, ["onClick", "loading"])), [
          [_directive_test, 'delete-team-button']
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("strong", null, _toDisplayString(_ctx.name), 1)
        ])
      ]),
      _: 1
    }),
    (_ctx.userIsOwner)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _hoisted_14,
          _hoisted_15,
          _withDirectives((_openBlock(), _createBlock(_component_AppButton, {
            theme: "danger",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ModalHandlerService.open('delete-team')))
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })), [
            [_directive_test, 'open-delete-modal']
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}